import Vue from 'vue'
import lang from 'element-ui/lib/locale'
import locale from 'element-ui/lib/locale/lang/ko'
import {
  Autocomplete,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Collapse,
  CollapseItem,
  Container,
  DatePicker,
  Dialog,
  Form,
  FormItem,
  Image,
  Input,
  InputNumber,
  Link,
  Loading,
  Main,
  Menu,
  MenuItem,
  Message,
  MessageBox,
  Option,
  Pagination,
  Popover,
  Progress,
  Radio,
  RadioButton,
  RadioGroup,
  Rate,
  Row,
  Scrollbar,
  Select,
  Step,
  Steps,
  Submenu,
  Switch,
  TabPane,
  Tabs,
  Tooltip,
  Tree,
  Upload,
} from 'element-ui'
import ToastNotification from './common/toastNotification'

lang.use(locale)

const components = [
  Autocomplete,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Collapse,
  CollapseItem,
  Container,
  DatePicker,
  Dialog,
  Form,
  FormItem,
  Image,
  Input,
  InputNumber,
  Link,
  Main,
  Menu,
  MenuItem,
  Option,
  Pagination,
  Popover,
  Progress,
  Radio,
  RadioButton,
  RadioGroup,
  Rate,
  Row,
  Scrollbar,
  Select,
  Step,
  Steps,
  Submenu,
  Switch,
  TabPane,
  Tabs,
  Tooltip,
  Tree,
  Upload,
]

components.forEach(c => Vue.use(c))

Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = ToastNotification
